import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { WorkerPool } from "types/generated";
import useCanUpdateWorkerPool from "shared/WorkerPool/access/useCanUpdateWorkerPool";

type WorkerPoolUpdateActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const WorkerPoolUpdateAction = ({ onAction, workerPool }: WorkerPoolUpdateActionProps) => {
  const canUpdateWorkerPool = useCanUpdateWorkerPool()(workerPool);
  const managedByK8sController = workerPool.managedByK8sController;

  const getTooltip = () => {
    if (managedByK8sController) {
      return "The pool cannot be edited because it is managed by the Kubernetes controller. Please make any changes via Kubernetes.";
    }
    if (!canUpdateWorkerPool.result) {
      return canUpdateWorkerPool.message;
    }
    return null;
  };

  const isDisabled = !canUpdateWorkerPool.result || managedByK8sController;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltip={tooltip}
      isTooltipActive={!!tooltip}
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      onAction={onAction}
      isDisabled={isDisabled}
    >
      Edit
    </DropdownMenuItem>
  );
};

export default WorkerPoolUpdateAction;
